import { LanguageSelect } from './language-select';
import { ShippingCountrySelect } from './shipping-country-select';
import { useTranslator } from 'tradera/lang/translate';

type LocalizationMenuProps = {
    showRegionSelection: boolean;
};

export const LocalizationMenu = ({
    showRegionSelection,
}: LocalizationMenuProps) => {
    const { t } = useTranslator();
    return (
        <div className="mt-3">
            {showRegionSelection && (
                <>
                    <ShippingCountrySelect />
                    <div className="border-bottom" />
                </>
            )}
            <LanguageSelect title={t('siteHeader_language')} />
            <div className="border-bottom" />
        </div>
    );
};
